import { render } from "./Statements.vue?vue&type=template&id=58003869&scoped=true"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"

import "./Statements.vue?vue&type=style&index=0&id=58003869&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58003869"]])

export default __exports__